import { useSearchParams } from "react-router-dom";
import { GroupContent } from "../settings/groupContent";
import { AdminContent } from "../settings/adminContent";
import { CategoryOrdersContent } from "../settings/CategoryOrdersContent";
import { StatisticsContent } from "../settings/statisticsContent";
import { LogViewer } from "./LogViewer";
import { UserPanel } from "../settings/UserPanel";
import css from "./settingsView.module.css";

interface SettingsViewProps {
  onLogout(): void;
}

export function SettingsView(props: SettingsViewProps) {
  const [searchParams, setSearchParams] = useSearchParams();
  const showLogs = searchParams.get("logs") === "true";

  return (
    <div className={css.wrapper}>
      {showLogs && (
        <LogViewer
          onClose={() => {
            setSearchParams(
              (currentParams) => {
                const nextParams = new URLSearchParams(currentParams);
                nextParams.delete("logs");

                return nextParams;
              },
              { replace: true },
            );
          }}
        />
      )}

      <div className={css.header}>
        <h1 className={css.headerTitle}>Indstillinger</h1>
      </div>

      <div className={css.content}>
        <div className={css.section}>
          <div className={css.sectionHeader}>Gruppe</div>
          <div className={css.sectionContent}>
            <GroupContent />
          </div>
        </div>

        <div className={css.section}>
          <div className={css.sectionHeader}>Kategorirækkefølger</div>
          <div className={css.sectionContent}>
            <CategoryOrdersContent />
          </div>
        </div>

        <div className={css.section}>
          <div className={css.sectionHeader}>Statistik</div>
          <div className={css.sectionContent}>
            <StatisticsContent />
          </div>
        </div>

        <div className={css.section}>
          <div className={css.sectionHeader}>Varer</div>
          <div className={css.sectionContent}>
            <AdminContent />
          </div>
        </div>

        <div className={css.userPanel}>
          <UserPanel onLogout={props.onLogout} />
        </div>
      </div>
    </div>
  );
}
